import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import axios from "axios";
import { ContextData } from "../../../../../../../context/Context";
import baseUrl from "../../../../../../../BaseURL";
import EditIcon from '@mui/icons-material/Edit';
import UpdateEmailForm from "./UpdateEmailForm";

export default function ViewDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [QualificationList, setQualificationList] = React.useState(null);
  const { AdministratorTokens, UpdateAmount } = React.useContext(ContextData);

  // Get List of Qualification from the server

  React.useEffect(() => {
    async function FetchData() {
      //  setLoader(true)

      try {
        const response = await axios.get(`${baseUrl}/auth/get_amount`, {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${
              AdministratorTokens !== null && AdministratorTokens
            }`,
          },
        });

        setQualificationList(response.data);
        //    setLoader(false)
        console.log(QualificationList);
      } catch (err) {
        if (err) console.log(err.message);
        // setLoader(false)
      }
    }
    FetchData();
  }, []);

  return (
    <div className="appicant-profile-dialog-con">
      <Button variant="contained" onClick={handleClickOpen}
        sx={{width:"10rem", height:"10rem", padding:"2rem"}}
        startIcon={<EditIcon />}
      >
        Update Email
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
    

        <DialogContent>
            <UpdateEmailForm />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
